import React from 'react';
import { i18n as I18n } from 'utils/i18n';
import FrequentlyAskedQuestionsItems from './frequentlyAskedQuestionsItems';

import {
  basics,
  gettingStarted,
  setupPayments,
  bookingsCancellations,
  usingRoomOnSite,
} from '../../constants/faqs';

interface QuestionAnswer {
  question: string;
  answer?: string;
  roomTypes: object;
  introText?: string;
  endText?: string;
  listItems?: Array<string>;
  formattedText?: boolean;
  hyperlinks?: Array<object>;
  hyperlinksIntroText?: string;
}

interface ListItem {
  href?: string;
  text: string;
}

const FrequentlyAskedQuestions: React.FC = () => {
  const renderBackToTop = () => {
    return (
      <a
        className="button button--right button--text button--link"
        href="#faqIntro"
      >
        {I18n.t('shared.back_to_top')}
      </a>
    );
  };

  const renderQuestionsAnswers = (item: QuestionAnswer) => {
    return (
      <FrequentlyAskedQuestionsItems
        question={item.question}
        answer={item.answer}
        roomTypes={item.roomTypes}
        introText={item.introText}
        endText={item.endText}
        listItems={item.listItems}
        formattedText={item.formattedText}
        hyperlinks={item.hyperlinks}
        hyperlinksIntroText={item.hyperlinksIntroText}
      />
    );
  };

  const renderGettingStartedList = () => {
    const listItems: ListItem[] = I18n.t('faq.topics.how_to_use.linked_list', {
      returnObjects: true,
    }) as ListItem[];

    return (
      <ul className="faq__formatted-list">
        {listItems.map((item, index) => (
          <li key={index}>
            {item.href ? (
              <a href={item.href} target="_blank" rel="noreferrer">
                {item.text}
              </a>
            ) : (
              item.text
            )}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <>
      <span id="howToUse">&nbsp;</span>
      <h3>{I18n.t('faq.topics.how_to_use.title')}</h3>
      <div className="faq__topics">
        <p>
          {I18n.t('faq.topics.how_to_use.intro_text_start')}
          <a
            href={I18n.t('faq.topics.how_to_use.intro_text_hyperlink.link')}
            target="_blank"
            rel="noreferrer"
          >
            {I18n.t('faq.topics.how_to_use.intro_text_hyperlink.text')}
          </a>
          {I18n.t('faq.topics.how_to_use.intro_text_end')}
        </p>
        <br />
        <p>
          {I18n.t('faq.topics.how_to_use.list_items_intro')}
          {renderGettingStartedList()}
        </p>
        {renderBackToTop()}
      </div>

      <span id="basics">&nbsp;</span>
      <h3>{I18n.t('faq.topics.basics.title')}</h3>
      <div className="faq__topics">
        {basics.map(item => renderQuestionsAnswers(item))}
        {renderBackToTop()}
      </div>

      <span id="gettingStarted">&nbsp;</span>
      <h3>{I18n.t('faq.topics.getting_started.title')}</h3>
      <div className="faq__topics">
        {gettingStarted.map(item => renderQuestionsAnswers(item))}
        {renderBackToTop()}
      </div>

      <span id="setupPayments">&nbsp;</span>
      <h3>{I18n.t('faq.topics.setup_payments.title')}</h3>
      <div className="faq__topics">
        {setupPayments.map(item => renderQuestionsAnswers(item))}
        {renderBackToTop()}
      </div>

      <span id="bookingsCancellations">&nbsp;</span>
      <h3>{I18n.t('faq.topics.bookings_cancellations.title')}</h3>
      <div className="faq__topics">
        {bookingsCancellations.map(item => renderQuestionsAnswers(item))}
        {renderBackToTop()}
      </div>

      <span id="usingRoomsOnSite">&nbsp;</span>
      <h3>{I18n.t('faq.topics.using_room_on_site.title')}</h3>
      <div className="faq__topics">
        {usingRoomOnSite.map(item => renderQuestionsAnswers(item))}
        {renderBackToTop()}
      </div>

      <ul className="unstyled">
        <li>
          <b>{I18n.t('faq.chp_contact_intro')}</b>
        </li>
        <li>
          {I18n.t('faq.email')}:{' '}
          <a href={`mailto:${I18n.t('faq.chp_email')}`}>
            {I18n.t('faq.chp_email')}
          </a>
        </li>
        <li>
          {I18n.t('faq.telephone')}: {I18n.t('faq.chp_phone')}
        </li>
      </ul>
      <br />
      <ul className="unstyled">
        <li>
          <b>{I18n.t('faq.nhs_contact_intro')}</b>
        </li>
        <li>
          {I18n.t('faq.email')}:{' '}
          <a href={`mailto:${I18n.t('faq.nhs_email')}`}>
            {I18n.t('faq.nhs_email')}
          </a>
        </li>
        <li>
          {I18n.t('faq.telephone')}: {I18n.t('faq.nhs_phone')}
        </li>
      </ul>
    </>
  );
};

export default FrequentlyAskedQuestions;
